export default function setupAxios(axios) {
  axios.interceptors.request.use(
    (config) => {
      config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
      return config;
    },
    (err) => Promise.reject(err)
  );
}
